import type { NonCompliantSupplierRow } from '@cls/shared';
import { CompSection, EmptyOk } from '../CompSection.js';

interface Props {
  rows: NonCompliantSupplierRow[];
}

export function SuppliersSection({ rows }: Props) {
  return (
    <CompSection title={`⚠ Non-Compliant Suppliers (${rows.length})`} type="warn">
      {rows.length ? (
        <table>
          <thead>
            <tr>
              <th>Supplier</th>
              <th>Category</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((s) => (
              <tr key={s.id}>
                <td>{s.name}</td>
                <td>{s.category}</td>
                <td>
                  <span className="badge b-expired">Non-Compliant</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <EmptyOk message="All suppliers compliant" />
      )}
    </CompSection>
  );
}
